<template>
  <div>
    <div style="padding-bottom:10px">
      <i class="fas fa-arrow-left" style="border:1px solid #ccc;padding:10px;cursor:pointer" @click="goback"> </i>
    <span style="font-size:24px;font-weight:500"> Edit Product</span>
    </div>

     <CCard>
        <CCardBody>
          <div class="row">
            <div class="col">
                <CInput
                        v-model="user.brand"
                        placeholder="Brand"
                        label = "Brand:"
                        autocomplete="brand"
                      />
            </div>
            <div class="col">
            <CInput
                         v-model="user.name"
                        placeholder="Product name"
                        label = "Name of the product:"
                        autocomplete="name"
                      />
             </div>
            </div>
            <div class="row">
            <div class="col">
               <CInput
                        placeholder="Enter SKU"
                        v-model="user.skucode"
                        label = "SKU:"
                      />
            </div>
            <div class="col">
               <CInput
                        placeholder="Enter Weight"
                        v-model="user.weight"
                        label = "Unit-kg:"
                        autocomplete="number"
                      />
            </div>
            <div class="col">
              <CInput
                      placeholder="Enter MRP"
                      v-model="user.mrp"
                      label = "MRP:"
                  />
            </div>
            <div class="col">
               <CInput
                      placeholder="Enter Retail price"
                      v-model="user.unitprice"
                      label="Retail Price:"
                  />
            </div>
            </div>
            <div class="row">
              <div class="col-3">
                 <CInput
                      placeholder="Enter Discount"
                      v-model="user.discount"
                      label="Discount:"
                  />
              </div>
              <div class="col-3">
                 <CInput
                      placeholder="Enter Barcode"
                      v-model="user.barcode"
                      label="Barcode:"
                  />
              </div>
<div class="col-3" style="margin-top:1rem;margin-bottom:1rem">
<span class="label">Availability:</span>
                  <br />
                  <div>
                    <CSwitch
                      class="mx-1"
                      color="success"
                      name="switch1"
                      :checked.sync="available"
                      variant="3d"
                      size="sm"
                      style="margin-bottom: -5px"
                    />
                    <CBadge v-if="available">
                      <h6
                        class="form-input"
                        style="display: inline-block; margin: 5px"
                      >
                        Enable
                      </h6>
                    </CBadge>
                    <CBadge v-else>
                      <h6
                        class="form-input"
                        style="display: inline-block; margin: 5px"
                      >
                        Disable
                      </h6>
                    </CBadge>
                  </div>
</div>

<div class="col-3" style="margin-top:1rem;margin-bottom:1rem">
<span class="label">Featured:</span>
                  <br />
                  <div>
                    <CSwitch
                      class="mx-1"
                      color="success"
                      name="switch1"
                      :checked.sync="user.featured"
                      variant="3d"
                      size="sm"
                      style="margin-bottom: -5px"
                    />
                    <CBadge v-if="user.featured">
                      <h6
                        class="form-input"
                        style="display: inline-block; margin: 5px"
                      >
                        Enable
                      </h6>
                    </CBadge>
                    <CBadge v-else>
                      <h6
                        class="form-input"
                        style="display: inline-block; margin: 5px"
                      >
                        Disable
                      </h6>
                    </CBadge>
                  </div>
</div>

            </div>
            <CCol
                  sm="12"
                  md="12"
                  lg="12"
                  style="
                    border-top: 1px solid gainsboro;
                    padding-top: 10px;
                    padding-bottom: 10px;
                  "
                >
                </CCol>
                <CCol style="padding-bottom:30px">
                    <span style="color: #24282c;">
                    Categories
                  </span>
                  <v-select
                    v-model="user.category"
                    :options="category"
                    v-if="category" multiple
                    placeholder="Select Category"
                   
                  />
                </CCol>
                <CCol style="border-top:1px solid gainsboro;padding-top:15px;padding-bottom:15px">
                  <CRow>
                    <CCol lg="4" style="margin-top:1rem;margin-bottom:1rem">
                       <img
                      :src="user.Image"
                      style="width: 115px; height: 115px; margin: 10px"
                      class="img-thumbnail"
                    />
                    </CCol>
                    <CCol lg="8">
                      <div style="padding-top: 25px">
                        <CCard>
                          <CCardHeader> Upload Image </CCardHeader>
                          <CCardBody>
                            <div class="row">
                              <div class="col-8">
                                <label> Upload/change product image </label>

                                <input
                                  type="file"
                                  @change="onImageSelected"
                                  accept="image/*"
                                  class="form-control"
                                />
                              </div>
                              <div class="col">
                                <div
                                  @click="deleteImage"
                                  style="
                                    background: gainsboro;
                                    cursor: pointer;
                                    border-radius: 3rem;
                                    text-align: center;
                                    padding-top: 4px;
                                    padding-bottom: 4px;
                                    margin-top: 2rem;
                                    margon-bottom: 1rem;
                                    border: 1px solid gainsboro;
                                  "
                                >
                                  <span> Delete </span>
                                </div>
                              </div>
                            </div>
                          </CCardBody>
                        </CCard>
                      </div>
                    </CCol>
                  </CRow>
                </CCol>
                 <CCol>
                  <CCard style="min-height: 200px;margin-right:-10px;margin-left:-10px">
                    <CCardHeader>
                      <span style="font-size: 16px; color: #24282c">
                        Description:
                      </span>
                    </CCardHeader>
                    <CCardBody>
                       <quill-editor
                        :content="user.description"
                        v-model="user.description"
                         style="
                          height: 100%;
                          margin-top: 10px;
                          margin-left: 10px;
                          margin-right: 10px;
                          margin-bottom: 10px;
                        "

                      />
                    </CCardBody>  
                  </CCard>
                </CCol>
                 <CCol
                  sm="12"
                  md="12"
                  lg="12"
                  style="
                    border-top: 1px solid gainsboro;
                    padding-top: 10px;
                    padding-bottom: 10px;
                  "
                >
                </CCol>
                <CCol>
                         <label class="container">Add Taxes
  <input type="checkbox" checked="checked">
  <span class="checkmark"></span>
</label>
                </CCol>
                <CCardFooter>
                   <b-button
                      variant="danger"
                      style="
                        float: right;
                        border-radius: 10rem;
                      "
                      @click="update"
                    >
                      Save & Submit
                      <b-spinner
                      v-if="productupdate"
                        small
                        type="grow"
                      ></b-spinner>
                    </b-button>

                  <!-- <b-button
                       variant="danger"
                       style="
                        float: right;
                        padding-right: 2rem;
                        padding-left: 2rem;
                        border-radius: 10rem;
                      "
                      @click="cancel"
              >
                     Cancel
                 </b-button>
                 &nbsp;&nbsp;&nbsp;&nbsp; -->
                </CCardFooter>
             </CCardBody>
         </CCard>
              <!-- <h4 style="font-size: 16px;line-height: 120%;color: #24282c;margin-left: 20px;padding-top: 11px;"> Stock Control</h4>
              <span style="font-size: 14px;font-weight: bold;color: #37ba32;margin-left: 20px;margin-bottom: 20px;">
                In Stock
                <span style="color:black;margin-right: 15px;"> (∞)</span>
                <span style="color:#068eef">[&nbsp; Manage&nbsp;]</span>
              </span>
              <hr style="margin-top:0px">
              <span style="color: #068eef;font-weight: bold;margin-left: 20px;"> Preview Product </span>
              <span style="color: #068eef;font-weight: bold;margin-left: 20px;"> Open in storefront </span>
              <CRow style="margin:20px">
                <i class="fab fa-facebook-square" style="font-size: 24px;color: #068eef;margin-right:10px"></i>
                <i class="fab fa-twitter-square" style="font-size: 24px;color: #068eef;"></i>
              </CRow> --> 
  </div> 
</template>
<script>
  import firebase from "firebase";
  import { uuid } from "vue-uuid";

  // import userService from '@/services/userService.js';
  // import jwtService from '@/services/utils.js'
  import VueQuillEditor from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import Vue from 'vue'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import { brandSet as brands } from '@coreui/icons'
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});
  Vue.use(VueQuillEditor)
import * as VueSpinnersCss from "vue-spinners-css";
 
Vue.use(VueSpinnersCss)

  export default {
    brands,
    components: {
      vSelect
    },
    data() {
      return {
        symbol : null,
        content : null,
        manage : false,
        checker : true,
        selected: [],
        variant : false,
        viewerOptions: {
          rootObjectKey: "Product"
        },
        inputs: [{
          name: '',
          price: ''
        }],
        extras: [{
          name: '',
          price: ''
        }],
        available: false,
        extra : false,
        category : null,
        catalogOption:[],
        hubList: [],
        id:"",
        centersList: [],
        dePersionList: [],
        locChangeHistory :[],
        fields:[
          {key: 'time', label:'Created Date'},
          {key: 'owner', label: 'Owner'},
          {key: 'message', label: 'Info', sortable: true},
        ],
        productDetails: null,
        userDetails: null,
        timeline:{},
        blochainData:{},
        show: true,
        url: '',
        file: null,
        submitted: false,
        url2: '',
              img1: "",
      imageData: null,
      imageFileDisp: null,
        editim: null,
        user: {
          brand:'',
          name: '',
          unitprice: '',
          weight: '',
          expiry: '',
          description: '',
          warranty: '',
          quality: '',
          manufacturer: '',
          category: '',
          catalog:'',
          certification: '',
          company: '',
          unitofquantity: '',
          Image: '',
          quantity: '',
          skucode: '',
          featured : false
        },
        fname: '',
        urlimage: '',
      }
    },
    methods: {
        deleteImage() {
      this.imageFileDisp = false;
    },
         

            onImageSelected(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createFileImage(files[0]);
      this.previewImage(e);
    },
        previewImage: function (event) {
      this.uploadValue = 0;
      this.img1 = null;
      this.imageData = event.target.files[0];
      this.uuidvalue = uuid.v1();
      this.onUpload();
    },

    createFileImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.imageFileDisp = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onUpload() {
      this.img1 = null;
      const storageRef = firebase
        .storage()
        .ref(this.uuidvalue)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.img1 = url;
            this.user.Image = url;
            console.log(this.user.Image);
            return this.img1;
          });
        }
      );
    },


      add () {
      this.inputs.push({
        name: '',
        price: ''
      })
    },
    remove (index) {
      this.inputs.splice(index, 1)
    },
          cancel(){
        this.$router.push({path:"productlist"})
      },

    add_extra () {
      this.extras.push({
        name: '',
        price: ''
      })
      console.log("extra",this.extras)
    },
    remove_extra (index) {
      this.extras.splice(index, 1)
    },
      enable(){
        console.log("Before",this.user.enable)
        this.user.enable = !this.user.enable
        console.log("After",this.user.enable)
      },
      getCategoryList(){
        let temp = [];
        const db = firebase.firestore()
        db.collection('category')
        .where('id', '==' ,firebase.auth().currentUser.uid)
        .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              temp.push(doc.data().name)
            })
            this.category = temp;
            console.log("Category",this.category)
          })
          .catch(err => {
            console.log(err)
          })
      },
      
                  getCatalogList(){
        let temp = [];
        const db = firebase.firestore()
        db.collection('catalog')
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              console.log("Catalog list",doc.data())
              this.catalogOption.push(doc.data().name)
            })
            // this.catalog = temp;
            console.log("Catalog",this.catalog)
          })
          .catch(err => {
            console.log(err)
          })
      },

    goback(){
                this.$router.push("/productlist");

    },

      getProductDetails() {
         let id = this.$route.params.id;
         console.log(id,"ID")
         console.log(this.$route.params)
         let data = this.$route.params.data
         this.user = data
         this.user.enable = true
         this.variant = this.user.variant
         this.inputs = this.user.variants
         this.extra = true
         this.extras = this.user.extras
         this.available=this.user.available
         console.log("User in product details",this.user)
      },
      update() {
        const db = firebase.firestore()
        this.id = this.$route.params.id;
        this.user.available = this.available
        this.user.variant = this.variant
        this.user.variants = this.inputs
        this.user.extra = this.extra
        this.user.extras = this.extras
        let productRef = db.collection('products').doc(this.id);
        for (let [key, value] of Object.entries(this.user)) {
          if(key && !value){
            this.user[key] = null;
          }
        }
        return productRef.update(this.user)
        .then(()=>{
                    Vue.$toast.success("Product updated successfully!",{
              // override the global option
              position: "top-right",
            });

          this.$router.push('/productlist')
        })
        .catch((error) => {
                    Vue.$toast.error(error.message,{
              // override the global option
              position: "top-right",
            });

          console.log(error);
        });
      },


    },
    created() {
      this.getProductDetails()
      this.getCategoryList()
      this.getCatalogList()
       this.symbol = localStorage.getItem("symbol")
    },
  }

</script>
<style scoped>
  .image-wrapper {
    display: table-cell;
    width: 125px;
    height:125px;
    vertical-align: middle;
    border: 1px solid black;
  }
  .image-wrapper img {
    max-width: 100%;
    max-height: 100%;
    display: block;
    margin: 0 auto;
  }
  .error {
    color: red;
  }

  .currentholder{
    background:#67d267  !important
  }

  /* .ifdre {
    height: 45% !important;
    padding-left: 7%;
    width: 51%;
    float: right;
    padding-bottom: 3%;
     margin-right: -24%;
  } */

  .ifdre {
    /* padding-left: 7%; */
    float: left;
    height: 147px;
    /*padding-left: 370px;*/
  }

  textarea.form-control {
    height: 211%;
  }

  .fileimage {
    /* float: right; */
    padding-left: 70% !important;
    padding-top: -4%;
    position: relative;
    /* top: 5%; */
    width: 100%;

  }

  .filetop {

    margin-top: -112px;
  }

  /* Timeline */
  .timeline,
  .timeline-horizontal {
    list-style: none;
    padding: 20px;
    position: relative;
  }

  .timeline:before {
    top: 40px;
    bottom: 0;
    position: absolute;
    content: " ";
    width: 3px;
    background-color: #eeeeee;
    left: 50%;
    margin-left: -1.5px;
  }

  .timeline .timeline-item {
    margin-bottom: 20px;
    position: relative;
  }

  .timeline .timeline-item:before,
  .timeline .timeline-item:after {
    content: "";
    display: table;
  }

  .timeline .timeline-item:after {
    clear: both;
  }

  .timeline .timeline-item .timeline-badge {
    color: #fff;
    width: 54px;
    height: 54px;
    line-height: 52px;
    font-size: 22px;
    text-align: center;
    position: absolute;
    top: 18px;
    left: 50%;
    margin-left: -25px;
    background-color: #7c7c7c;
    border: 3px solid #ffffff;
    z-index: 100;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
  }

  .timeline .timeline-item .timeline-badge i,
  .timeline .timeline-item .timeline-badge .fa,
  .timeline .timeline-item .timeline-badge .glyphicon {
    top: 2px;
    left: 0px;
  }

  .timeline .timeline-item .timeline-badge.primary {
    background-color: #1f9eba;
  }

  .timeline .timeline-item .timeline-badge.info {
    background-color: #5bc0de;
  }

  .timeline .timeline-item .timeline-badge.success {
    background-color: #59ba1f;
  }

  .timeline .timeline-item .timeline-badge.warning {
    background-color: #d1bd10;
  }

  .timeline .timeline-item .timeline-badge.danger {
    background-color: #ba1f1f;
  }

  .timeline .timeline-item .timeline-panel {
    position: relative;
    width: 46%;
    float: left;
    right: 16px;
    border: 1px solid #c0c0c0;
    background: #ffffff;
    border-radius: 2px;
    padding: 20px;
    -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
  }

  .timeline .timeline-item .timeline-panel:before {
    position: absolute;
    top: 26px;
    right: -16px;
    display: inline-block;
    border-top: 16px solid transparent;
    border-left: 16px solid #c0c0c0;
    border-right: 0 solid #c0c0c0;
    border-bottom: 16px solid transparent;
    content: " ";
  }

  .timeline .timeline-item .timeline-panel .timeline-title {
    margin-top: 0;
    color: inherit;
  }

  .timeline .timeline-item .timeline-panel .timeline-body>p,
  .timeline .timeline-item .timeline-panel .timeline-body>ul {
    margin-bottom: 0;
  }

  .timeline .timeline-item .timeline-panel .timeline-body>p+p {
    margin-top: 5px;
  }

  .timeline .timeline-item:last-child:nth-child(even) {
    float: right;
  }

  .timeline .timeline-item:nth-child(even) .timeline-panel {
    float: right;
    left: 16px;
  }

  .timeline .timeline-item:nth-child(even) .timeline-panel:before {
    border-left-width: 0;
    border-right-width: 14px;
    left: -14px;
    right: auto;
  }

  .timeline-horizontal {
    list-style: none;
    position: relative;
    padding: 20px 0px 20px 0px;
    display: inline-block;
  }

  .timeline-horizontal:before {
    height: 3px;
    top: auto;
    bottom: 26px;
    left: 56px;
    right: 0;
    width: 100%;
    margin-bottom: 20px;
  }

  .timeline-horizontal .timeline-item {
    display: table-cell;
    height: 280px;
    width: 20%;
    min-width: 250px;
    float: none !important;
    padding-left: 0px;
    padding-right: 20px;
    margin: 0 auto;
    vertical-align: bottom;
  }

  .timeline-horizontal .timeline-item .timeline-panel {
    top: auto;
    bottom: 64px;
    display: inline-block;
    float: none !important;
    left: 0 !important;
    right: 0 !important;
    width: 100%;
    margin-bottom: 20px;
  }

  .timeline-horizontal .timeline-item .timeline-panel:before {
    top: auto;
    bottom: -16px;
    left: 28px !important;
    right: auto;
    border-right: 16px solid transparent !important;
    border-top: 16px solid #c0c0c0 !important;
    border-bottom: 0 solid #c0c0c0 !important;
    border-left: 16px solid transparent !important;
  }

  .timeline-horizontal .timeline-item:before,
  .timeline-horizontal .timeline-item:after {
    display: none;
  }

  .timeline-horizontal .timeline-item .timeline-badge {
    top: auto;
    bottom: 0px;
    left: 43px;
  }

  .linwh {
    color: white;
  }
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #ff0000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

</style>
